// フォントサイズ設定
const FontSize = {
  namespaced: true,

  state: {
    fontSize: 'sm', // sm, lg, md
  },
  getters: {
    getFontSize: state => {
      return state.fontSize
    },
  },
  mutations: {
    setFontSize(state, fontSize) {
      state.fontSize = fontSize
    },
  },
  actions: {
    setFontSize({ commit }, fontSize) {
      commit('setFontSize', fontSize)
    },
  },
}

export default FontSize
